// extracted by mini-css-extract-plugin
module.exports = {"element":"styles-module__element___3WS6r"};